import {canSeeAddToCartButton, canSeeWishlistButton} from "~/utils/features";
import {displayBetterDeal} from "~/feature/ProductDescriptor/v1/productDescriptorUtils";
import {PRIMARY_BTN_VARIANT, SECONDARY_BTN_VARIANT, TERTIARY_BTN_VARIANT} from "~/common/components/Button/constants";
import {showManufacturerLogo} from "~/utils/product/showManufacturerLogo";
import {
  canSeeBuyFromSalesPartnerButton
} from "~/feature/SalesPartnerStockIntegration/salesPartnerStockIntegrationHelper";
import type {ProductDescriptor} from "~/feature/ProductDescriptor/v1/types";

interface Props {
  product: ProductDescriptor;
  qtyInCart: number;
  quantity?: number;
  packCode: string;
  packSize?: number;
}

export const usePdpSummaryLogic = ({ product, qtyInCart, packCode, packSize = 1, quantity = 0 }: Props) => {
  const showBuyFromSalesPartnerButton = canSeeBuyFromSalesPartnerButton();
  const showCartButton = canSeeAddToCartButton();
  const showWishlistButton = canSeeWishlistButton();

  const variants = [PRIMARY_BTN_VARIANT, SECONDARY_BTN_VARIANT, TERTIARY_BTN_VARIANT, TERTIARY_BTN_VARIANT];
  let buyFromSalesPartnerButtonProps = {},
    cartButtonProps = {},
    wishlistButtonProps = {};

  if (showBuyFromSalesPartnerButton) {
    buyFromSalesPartnerButtonProps = variants.shift()!;
  }

  if (showCartButton) {
    cartButtonProps = variants.shift()!;
  }
  if (showWishlistButton) {
    wishlistButtonProps = variants.shift()!;
  }
  const configureButtonProps = variants.shift()!;

  const buttons = {
    showBuyFromSalesPartnerButton,
    showCartButton,
    showWishlistButton,
    buyFromSalesPartnerButtonProps,
    cartButtonProps,
    wishlistButtonProps,
    configureButtonProps,
  };

  let showBetterDeal = false;
  const isPriceLoaded = !!product.prices.length;
  if (isPriceLoaded) {
    const totalQty = quantity + qtyInCart;
    showBetterDeal = displayBetterDeal({ product: product, packCode }, totalQty);
  }

  const isPackageSelected = !!packCode;
  const isAvailabilityLoaded = !!product.availability;

  let isPackageSizeInvalid = false;
  if (isAvailabilityLoaded && isPackageSelected) {
    isPackageSizeInvalid = quantity === 0 || !Number.isInteger(quantity / packSize);
  }

  return {
    buttons,
    flags: {
      showBetterDeal,
      isPackageSizeInvalid,
      showManufacturerLogo: showManufacturerLogo(product.base.manufacturerLogoUrl, product.base.isOptime),
    },
  };
};
